import { useCallback, useEffect, useState } from 'react';
import {
  getCachedSiteMessageUnreadCount,
  refreshSiteMessageUnreadCount,
  SITE_MESSAGE_UNREAD_POLL_INTERVAL_MS,
  startSiteMessageUnreadPolling,
  stopSiteMessageUnreadPolling,
  subscribeSiteMessageUnreadCount,
} from '@/utils/siteMessageUnread';

export { SITE_MESSAGE_UNREAD_POLL_INTERVAL_MS };

type UseSiteMessageUnreadCountOptions = {
  /** 是否开启 30s 轮询（仅 Header 使用） */
  enablePolling?: boolean;
  /** 挂载时拉取一次未读数（收件箱进入时使用） */
  refreshOnMount?: boolean;
};

export default function useSiteMessageUnreadCount(
  options: UseSiteMessageUnreadCountOptions = {},
) {
  const { enablePolling = false, refreshOnMount = false } = options;
  const [unreadCount, setUnreadCount] = useState(
    getCachedSiteMessageUnreadCount,
  );

  useEffect(() => {
    return subscribeSiteMessageUnreadCount(setUnreadCount);
  }, []);

  useEffect(() => {
    if (refreshOnMount) {
      void refreshSiteMessageUnreadCount();
    }
  }, [refreshOnMount]);

  useEffect(() => {
    if (!enablePolling) {
      return;
    }
    startSiteMessageUnreadPolling();
    return () => {
      stopSiteMessageUnreadPolling();
    };
  }, [enablePolling]);

  const refreshUnreadCount = useCallback(() => {
    return refreshSiteMessageUnreadCount();
  }, []);

  return { unreadCount, refreshUnreadCount };
}
